import { enqueueSnackbar } from 'notistack';
export const showSuccessApiResponseSnackbar = (header) => enqueueSnackbar({ variant: 'success', header });
